import React from 'react';
import { GridComponent, ColumnsDirective, ColumnDirective, Inject, Sort, Filter, Search, Toolbar, VirtualScroll } from '@syncfusion/ej2-react-grids';

import { formatDate, formatHeure } from '../utils/Format';
import { sanitizeText } from '../utils/SanitizeText';

const ListDocs = ({ lstDocs, type }) => {

    const handleRowDoubleClick = (event) => {
        const clickedRowData = event.rowData;
        const uuid = clickedRowData.UUID_;
        // if (uuid) navigate(`/dommages/${uuid}`);
    };

    lstDocs.forEach((doc) => {
        doc.Date_Fix = (doc.Date_Rdv === '0000-00-00') ? ((doc.Date_Convoc === '0000-00-00' ? '' : doc.Date_Convoc)) : doc.Date_Rdv;
            doc.Heure_Fix = formatHeure((doc.Date_Rdv === '0000-00-00') ? ((doc.Date_Convoc === '0000-00-00' ? '' : doc.Heure_Convoc)) : doc.Heure_Rdv) ? formatHeure((doc.Date_Rdv === '0000-00-00') ? ((doc.Date_Convoc === '0000-00-00' ? '' : doc.Heure_Convoc)) : doc.Heure_Rdv) : 'Non Renseignée';
            doc.Titre = sanitizeText(doc.Titre);
    });

    // console.log(lstDocs);

    return (
        <div className="bg-white p-4 rounded-lg">
            <div className="flex lg:flex-row flex-col justify-between items-start lg:items-center mx-auto my-4 lg:my-8 px-6 pb-4 border-gray-300 border-b container">
                <div>
                    <h4 className="font-bold text-gray-800 text-2xl leading-tight">{type}s</h4>
                    <ul className="flex md:flex-row flex-col items-start md:items-center mt-3 text-gray-600 text-sm">
                        <li className="flex items-center mt-3 md:mt-0 mr-3">
                            <span className="mr-2">
                                <i class="fa-pen-fancy fa-solid"></i>
                            </span>
                            <span>
                                {lstDocs.length}{' '}
                                {lstDocs.length === 1 ? type : `${type}s`}
                            </span>
                        </li>
                    </ul>
                </div>
                <div className="mt-6 lg:mt-0">
                    <button className="bg-orange-600 hover:bg-orange-500 px-8 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-orange-700 focus:ring-offset-2 text-white text-sm transition duration-300 ease-in-out">
                        Ajouter une {type}
                    </button>
                </div>
            </div>
            <div className="lg:mx-auto mb-4 lg:mb-8 px-6 container">
                <div className="border-2 border-gray-300 hover:border-orange-400 rounded w-full transition duration-300 ease-in-out grow">
                    <GridComponent
                        locale='fr'
                        dataSource={lstDocs}
                        allowSorting={true}
                        recordDoubleClick={handleRowDoubleClick}
                        toolbar={['Search']}
                        enableStickyHeader={true}
                        enableVirtualization={true}
                        height={520}
                        loadingIndicator={{ indicatorType: 'Shimmer' }}
                        searchSettings={{
                            fields: ['Libelle'],
                            placeholder: 'Rechercher...',
                        }}
                        sortSettings={{
                            columns: [{ field: '_Date_Crea', direction: 'Descending' }]
                        }}
                    >
                        <ColumnsDirective>
                            <ColumnDirective field="Titre" headerText="Titre" width="250px" />
                            <ColumnDirective field="Date_Fix" headerText="Date RDV" type="date" format="dd/MM/yyyy" width="140px" />
                            <ColumnDirective field="Heure_Fix" headerText="Heure RDV" width="140px" allowSorting={false} />
                            <ColumnDirective
                                field="_Signature"
                                headerText="Signature"
                                width="180px"
                            />
                            <ColumnDirective
                                field="_Modifie_Le"
                                headerText="Modifié le"
                                type="date"
                                format="dd/MM/yyyy"
                                width="130px"
                            />
                            <ColumnDirective
                                field="_Date_Crea"
                                headerText="Créé le"
                                type="date"
                                format="dd/MM/yyyy"
                                width="130px"
                            />
                        </ColumnsDirective>
                        <Inject services={[Sort, Filter, Search, Toolbar, VirtualScroll]} />
                    </GridComponent>
                </div>
            </div>
        </div>
    );
};

export default ListDocs
